import { render, staticRenderFns } from "./BlubberGlobalstream.vue?vue&type=template&id=befcf9ba&"
import script from "./BlubberGlobalstream.vue?vue&type=script&lang=js&"
export * from "./BlubberGlobalstream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v4.6-hsfl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('befcf9ba')) {
      api.createRecord('befcf9ba', component.options)
    } else {
      api.reload('befcf9ba', component.options)
    }
    module.hot.accept("./BlubberGlobalstream.vue?vue&type=template&id=befcf9ba&", function () {
      api.rerender('befcf9ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/BlubberGlobalstream.vue"
export default component.exports